<template>
  <div class="product">
    <div class="product-image">
      <div class="preview-image">
        <img :src="previewImage" />
      </div>
      <div
        v-for="img in formItem.mainImgUrlList"
        :key="img"
        :class="['main-image', previewImage == img ? 'main-image-active' : '']"
        @click="previewImage = img"
      >
        <img :src="img" />
      </div>
    </div>
    <div class="product-info">
      <Form :model="formItem" label-position="left">
        <FormItem label="SPU编码：">
          <p>{{ formItem.spuCode }}</p>
        </FormItem>
        <FormItem label="名称：">
          <p>{{ formItem.name }}</p>
        </FormItem>

        <!-- 新增字段 -->
        <FormItem label="商品类型">
          <p>{{ formItem.prdType == "normal" ? "一般贸易" : "保税贸易" }}</p>
        </FormItem>

        <FormItem label="商品货源">
          <p>
            {{ formItem.prdSource == "platform" ? "平台供货" : "门店自采" }}
          </p>
        </FormItem>

        <FormItem label="供货方式">
          <p>{{ formItem.supplyMode == "shop" ? "直供门店" : "直供用户" }}</p>
        </FormItem>

        <FormItem label="C端是否开启线下支付">
          <p>{{ formItem.customerOfflineFlag == "1" ? "是" : "否" }}</p>
        </FormItem>

        <FormItem label="建议零售价">
          <p>{{ formItem.recommendPrice }}</p>
        </FormItem>

        <FormItem label="分销限价">
          <p>{{ formItem.distributorPriceLimitFlag == "1" ? "是" : "否" }}</p>
        </FormItem>
        <div v-show="formItem.distributorPriceLimitFlag == 1">
          <FormItem label="分销限价最低价">
            <p>{{ formItem.distributorMinPrice }}</p>
          </FormItem>
          <FormItem label="分销限价最高价">
            <p>{{ formItem.distributorMaxPrice }}</p>
          </FormItem>
        </div>

        <FormItem label="零售限价">
          <p>{{ formItem.retailPriceLimitFlag == "1" ? "是" : "否" }}</p>
        </FormItem>
        <div v-show="formItem.retailPriceLimitFlag == 1">
          <FormItem label="零售限价最低价">
            <p>{{ formItem.retailMinPrice }}</p>
          </FormItem>
          <FormItem label="零售限价最高价">
            <p>{{ formItem.retailMaxPrice }}</p>
          </FormItem>
        </div>

        <FormItem label="云店限价">
          <p>{{ formItem.shopPriceLimitFlag == "1" ? "是" : "否" }}</p>
        </FormItem>
        <div v-show="formItem.shopPriceLimitFlag == 1">
          <FormItem label="云店限价最低价">
            <p>{{ formItem.shopMinPrice }}</p>
          </FormItem>
          <FormItem label="云店限价最高价">
            <p>{{ formItem.shopMaxPrice }}</p>
          </FormItem>
        </div>

        <FormItem label="产品代码：">
          <p>{{ formItem.prdCode }}</p>
        </FormItem>
        <FormItem label="起购数量：">
          <p>{{ formItem.leastBuyCnt }}</p>
        </FormItem>
        <FormItem label="步长：">
          <p>{{ formItem.buyStep }}</p>
        </FormItem>
        <FormItem label="限购数量：">
          <p>{{ formItem.maxBuyCnt }}</p>
        </FormItem>
        <FormItem label="产品规格：">
          <p>{{ formItem.prdStandard }} g</p>
        </FormItem>
        <FormItem label="毛重：">
          <p>{{ formItem.rweight }} g</p>
        </FormItem>
        <FormItem label="包装：">
          <p>{{ formItem.pkgUnit }} 听</p>
        </FormItem>
        <!-- <FormItem label="每听建议食用：">
          <p>{{ formItem.eatDays }} 天</p>
        </FormItem> -->
        <FormItem label="封面图：">
          <div v-if="formItem.coverImgUrl" class="main-image">
            <img :src="formItem.coverImgUrl" alt="" />
            <div class="delete" @click="deleteImage('coverImgUrl')"></div>
          </div>
        </FormItem>
        <FormItem label="保质期：">
          <p>{{ formItem.periodDays }} 天</p>
        </FormItem>
        <!-- <FormItem label="罐码：">
          <p>{{ formItem.tankCode }} 天</p>
        </FormItem>
        <FormItem label="罐码2：">
          <p>{{ formItem.tankCode2 }} 天</p>
        </FormItem> -->
        <!-- <FormItem label="商品条形码：">
          <p>{{ formItem.barCode }} 天</p>
        </FormItem>
        <FormItem label="appShowName：">
          <p>{{ formItem.appShowName }} 天</p>
        </FormItem> -->
        <FormItem label="产品简称：">
          <p>{{ formItem.erpCode }}</p>
        </FormItem>
        <FormItem label="是否POS">
          <p>{{ formItem.checkFlag == "1" ? "是" : "否" }}</p>
        </FormItem>
        <FormItem label="排序">
          <p>{{ formItem.sortIndex }}</p>
        </FormItem>
        <FormItem label="详情图：">
          <a @click="contentVisible = true">点击查看</a>
        </FormItem>
        <FormItem label="类目：">
          <p>{{ formItem.categoryCode }}</p>
        </FormItem>
        <FormItem label="属性：">
          <p>{{ formItem.propertyCode }}</p>
        </FormItem>
        <FormItem label="是否可退换货：">
          <p>{{ formItem.returnStatus == 1 ? "是" : "否" }}</p>
        </FormItem>
      </Form>
    </div>
    <router-link to="/skuInfo/list" slot="extra">返回列表</router-link>
    <!-- 详情图 -->
    <Modal v-model="contentVisible" title="详情图" width="70%">
      <div v-html="formItem.content"></div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      previewImage: "",
      contentVisible: false,
    };
  },

  computed: {
    ...mapGetters("skuInfo", {
      productSkuDetail: "getProductSkuDetail",
    }),
    formItem: function () {
      return (this.productSkuDetail && this.productSkuDetail.data) || {};
    },
  },
  created() {
    this.$store
      .dispatch("skuInfo/getProductSkuDetail", {
        skuCode: this.$route.query.code,
      })
      .then(() => {
        console.log(this.productSkuDetail);
        if (this.productSkuDetail.status !== "success") {
          this.$Message.error(res.message || "查询失败，请稍后重试！");
        }

        this.previewImage =
          (this.productSkuDetail &&
            this.productSkuDetail.data &&
            this.productSkuDetail.data.mainImgUrlList[0]) ||
          "";
      })
      .catch((err) => {
        this.$Message.error("查询失败，请稍后重试！");
      });
  },
  mounted() {},
  methods: {
    editorHandler() {
      const self = this;
      const editor = new E("#editor");
      editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        const fd = new FormData();
        fd.append("file", resultFiles[0]);
        self.$store
          .dispatch("uploadImage", fd)
          .then((res) => {
            if (res.code == 200) {
              insertImgFn(res.data.url);
            } else {
              self.$Message.error("图片上传失败");
            }
          })
          .catch((err) => {
            self.$Message.error("图片上传失败");
          });
      };
      // 配置 onchange 回调函数
      editor.config.onchange = function (newHtml) {
        self.formItem.content = newHtml;
      };
      // 配置触发 onchange 的时间频率，默认为 200ms
      editor.config.onchangeTimeout = 500;
      editor.create();
    },
    cancel() {
      this.$router.back();
    },
  },
};
</script>
<style scoped>
.product {
  display: flex;
  flex-direction: row;
}

.product .ivu-form-item {
  margin-bottom: 0;
}

.product-image {
  flex: 0 0 auto;
  /* width: 320px; */
  margin-right: 20px;
}

.preview-image {
  width: 320px;
  height: 320px;
  border: 1px solid #eaecf0;
  border-radius: 4px;
}

.preview-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.main-image {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  background-color: #f8f9fa;
  border: 1px solid #dcdfe6;
  margin-right: 6px;
  margin-top: 10px;
  overflow: hidden;
}

.main-image-active {
  border: 1px solid #1890ff;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-info {
  flex: 1 1 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/skuInfo/detail.vue